import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  roomContentItemWrapper: {
    paddingBottom: 12,
    paddingRight: 12,
  },
}));

export default styles;
